module.exports = __webpack_public_path__ + "static/media/rate_your_space.f6bd5ac8.svg";